module.exports = __webpack_public_path__ + "static/media/tomates.3e9c209e.svg";